













































import Vue from 'vue';
import SecondGraduationSendDocumentForm, {
  SendDocumentFormEvent,
} from '@/components/forms/SecondGraduationSendDocumentForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import { EvaluationSecondGraduation } from '@/store/modules/admission/state';
import { Toast, Loading } from '@/components/ds';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { evaluationStatusValues, EvaluationStatus } from '@/pipeline/stateMachine';

export default Vue.extend({
  components: {
    SecondGraduationSendDocumentForm,
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    Toast,
    Loading,
  },
  data() {
    return {
      document: { ...this.$store.getters.secondGraduation?.document },
      documentBack: { ...this.$store.getters.secondGraduation?.documentBack },
      isDocumentReadyForUpload: Boolean(this.$store.getters.secondGraduation?.document?.dataUrl),
      isUploadingDocuments: false,
      error: false,
      toastMessage: this.$t('errorMessage.secondGraduationInstitutionDocuments') as string,
      loading: false,
    };
  },
  computed: {
    admissionId(): number {
      return this.$store.getters.admissionId;
    },
    evaluationStatus(): string {
      return this.$store.getters.evaluationStatus;
    },
    name(): string {
      return this.$store.getters.user?.name || '';
    },
    secondGraduation(): EvaluationSecondGraduation {
      return this.$store.getters.secondGraduation;
    },
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch('PULL_EVALUATION_STATUS').catch(error => this.errorHandler(error));

    pipeline.next({ status: this.evaluationStatus });
    this.loading = false;
  },
  methods: {
    async deleteHandler(event: any, side: 'front' | 'back') {
      this.isDocumentReadyForUpload = false;

      await this.$store.dispatch('DELETE_SECOND_GRADUATION_DOCUMENT', { side });

      if (side === 'front') this.document = this.secondGraduation.document;
      else this.documentBack = this.secondGraduation.documentBack;
    },
    async finishHandler() {
      try {
        this.isUploadingDocuments = true;
        const secondGraduation: EvaluationSecondGraduation = {};

        await this.$store.dispatch('UPLOAD_SECOND_GRADUATION_DOCUMENT', {
          admissionId: this.admissionId,
          fileName: this.document.name,
          fileDataUrl: this.document.dataUrl,
          side: 'front',
        });

        if (this.documentBack.dataUrl) {
          await this.$store.dispatch('UPLOAD_SECOND_GRADUATION_DOCUMENT', {
            admissionId: this.admissionId,
            fileName: this.documentBack.name,
            fileDataUrl: this.documentBack.dataUrl,
            side: 'back',
          });
        }

        await this.$store.dispatch('UPDATE_SECOND_GRADUATION', { secondGraduation });

        this.$store.dispatch(AnalyticsActions.EVALUATION_SENT);

        await this.$store.dispatch('PULL_EVALUATION_STATUS');

        if (!evaluationStatusValues.includes(this.evaluationStatus as EvaluationStatus)) {
          // Curso/polo pode ter ficado indisponível no meio do envio do documento
          // (CHECK_ADMISSION_AVAILABILITIES zera o campus), deixando a avaliação presa
          // em 'executing'. pipeline.next() não teria efeito nenhum aqui.
          throw new Error('unavailableSelection');
        }

        pipeline.next({ status: this.evaluationStatus });
      } catch (error) {
        this.errorHandler(error);
      } finally {
        this.isUploadingDocuments = false;
      }
    },
    inputHandler({ documentBack, document }: SendDocumentFormEvent) {
      this.isDocumentReadyForUpload = document.isDocumentUploadDone;
      this.document.name = document.fileName;
      this.document.dataUrl = document.fileDataUrl;
      this.documentBack.name = documentBack.fileName;
      this.documentBack.dataUrl = documentBack.fileDataUrl;
    },
    errorHandler(error: any) {
      this.toastMessage =
        error instanceof Error && error.message === 'unavailableSelection'
          ? (this.$t('unavailableSelectionMessage') as string)
          : (this.$t('errorMessage.secondGraduationInstitutionDocuments') as string);
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
